export default {
  ads: {
    tower: 525839,
  },
};
